import { UserRouteActionV1Model } from '@core/models/entities/implementations/user-route-action-v1';
import {
  CarriedItem,
  JobPlacement,
  PlanEditGesture
} from '@core/models/plan-edit-gesture.model';
import { PinnedStop } from '@core/store/plan-edit/plan-edit.state';

import { jobMoveReleasesPin } from './pins';

/**
 * The gesture moving `carried` to `placement`. `MoveJob` releases no pin, so a gesture made of
 * `MoveJob`s asks for the release of the pin it would leave behind: a whole pinned stop sent to
 * another route, or the only job of a pinned stop. `from` is the carried job's stop as shown.
 * `null` for a tour aimed into a stop, which no tour target offers.
 */
export function moveGesture(
  carried: CarriedItem,
  placement: JobPlacement,
  pins: Record<string, PinnedStop>,
  from?: UserRouteActionV1Model
): PlanEditGesture | null {
  switch (carried.kind) {
    case 'stop':
      return {
        kind: 'move-stop',
        fromRouteUid: carried.routeUid,
        actionUid: carried.actionUid,
        jobUids: carried.jobUids,
        placement,
        releasesPin: placement.routeUid !== carried.routeUid && !!pins[carried.actionUid]
      };
    case 'job':
      return {
        kind: 'move-job',
        fromRouteUid: carried.routeUid,
        fromActionUid: carried.actionUid,
        jobUid: carried.jobUid,
        placement,
        releasesPin: jobMoveReleasesPin(from, pins)
      };
    case 'tour':
      return placement.kind === 'MergedInto'
        ? null
        : {
            kind: 'move-tour',
            fromRouteUid: carried.routeUid,
            actionUids: carried.actionUids,
            placement
          };
  }
}
